"use strict";

exports.__esModule = true;
exports.default = void 0;

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var ItemMatcher = function ItemMatcher() {
  var _this = this;

  _defineProperty(this, "keys", '');

  _defineProperty(this, "keysTimer", void 0);

  _defineProperty(this, "searchIndex", void 0);

  _defineProperty(this, "findMatchingItem", function (items, highlightedIndex, key) {
    if (!_this.isMatchableCharacter(key)) {
      return;
    }

    _this.searchIndex = highlightedIndex === undefined ? 0 : highlightedIndex + 1;
    _this.keys += key;

    _this.resetKeysAfterDelay();

    var match = _this.findMatchingItemInRange(items, _this.searchIndex, items.length) || _this.findMatchingItemInRange(items, 0, _this.searchIndex);

    return match;
  });

  _defineProperty(this, "findMatchingItemInRange", function (items, start, end) {
    var keys = _this.keys.toLowerCase();

    for (var index = start; index < end; index++) {
      var text = items[index].text;

      if (text && typeof text === 'string' && text.toLowerCase().indexOf(keys) === 0) {
        return items[index];
      }
    }
  });

  _defineProperty(this, "resetKeysAfterDelay", function () {
    if (_this.keysTimer) {
      global.clearTimeout(_this.keysTimer);
      _this.keysTimer = null;
    }

    _this.keysTimer = global.setTimeout(function () {
      _this.keys = '';
      _this.keysTimer = null;
    }, 500);
  });

  _defineProperty(this, "isMatchableCharacter", function (key) {
    return key.length === 1 && /\S/.test(key);
  });
};

exports.default = ItemMatcher;